import { MetricsKind } from "helpers/metrics/types";

export interface FinancialTargetFilter {
    field_name: string;
    value: string;
}

export interface FinancialTarget {
    id: string;
    name: string;
    target_group_id: string;
    dimensions: {
        id: string;
    }[];
    filters: FinancialTargetFilter[];
    created_at_ms: number;
    modified_at_ms: number;
}

export interface FinancialTargetBagValues {
    [key: string]: {
        string_value: string;
    };
}

export interface FinancialTargetBag {
    [key: string]: {
        map: {
            fields: FinancialTargetBagValues;
        };
    };
}

export interface FinancialTargetGroup {
    id: string;
    name: string;
    metric: MetricsKind;
}

export interface MappedFinancialTarget {
    targetId: string;
    targetGroupId: string;
    targetGroupName: string;
    filters: FinancialTargetFilter[];
    values: FinancialTargetBagValues;
    budgetTarget: MetricsKind;
}

export interface TargetWithTargetGroups extends FinancialTarget {
    targetGroup: FinancialTargetGroup;
}
export interface TargetGroupWithTargets extends FinancialTargetGroup {
    targets: FinancialTarget[];
}

export interface ITargetsData {
    [key: string]: string;
}

export enum RuleType {
    GenericError = "generic-error",
    NotEmptyRule = "not-empty-rule",
    NoDuplicateRowRule = "no-duplicate-row-rule",
    OnlyExistingDoorsRule = "only-existing-doors-rule",
    OnlyExistingDeliveriesRule = "only-existing-deliveries-rule",
    RequiredColumnsRule = "required-columns-rule",
}

export type ITargetsDataError = {
    [RuleType.GenericError]?: string;
    [RuleType.NotEmptyRule]?: string;
    [RuleType.NoDuplicateRowRule]?: string;
    [RuleType.OnlyExistingDoorsRule]?: string;
    [RuleType.OnlyExistingDeliveriesRule]?: string;
    [RuleType.RequiredColumnsRule]?: string;
};

export type TargetsUploaderContextValues = {
    handleDrop?: (file: File, onSettled: (error: boolean) => void) => Promise<void>;

    errorMessages: ITargetsDataError;
    isUploading: boolean;
    wasProcessed: boolean;
    hasDataToChange: boolean;
    parsedTargetsData: ITargetsData[];
};
